export default function Lock({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 16.875C11.5 16.875 11.125 16.5 11.125 16V14C11.125 13.5312 11.5 13.125 12 13.125C12.4688 13.125 12.875 13.5312 12.875 14V16C12.875 16.5 12.4688 16.875 12 16.875ZM19 11.5V18.5C19 19.3438 18.3125 20 17.5 20H6.5C5.65625 20 5 19.3438 5 18.5V11.5C5 10.6875 5.65625 10 6.5 10H7.5V8.5C7.5 6.03125 9.5 4 12 4C14.5 4.03125 16.5 6.0625 16.5 8.5625V10H17.5C18.3125 10 19 10.6875 19 11.5ZM9 10H15V8.5C15 6.875 13.625 5.5 12 5.5C10.3438 5.5 9 6.875 9 8.5V10ZM17.5 11.5H6.5V18.5H17.5V11.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
